// Import React
import React from 'react';

import {
  Deck,
  Heading,
  Image,
  Link,
  List,
  ListItem,
  Notes,
  Slide,
  Text
} from 'spectacle';

import styled from 'react-emotion';

import createTheme from 'spectacle/lib/themes/default';

require('normalize.css');

const theme = createTheme({
  primary: '#FFFFFF',
  secondary: '#40D082',
  tertiary: '#5AB0F4',
}, {
  primary: {
    name: 'Song Myung',
    googleFont: true
  },
  secondary: {
    name: 'Sunflower',
    googleFont: true
  }
});

const NiceHeading = styled(Heading)`
  letter-spacing: 0.75px;
  line-height: 1.05em;
  text-align: center;
  text-shadow: 0px 0px 2px #101010;
  margin: 0px auto 20px auto;
  `;

const SubHeading = styled(Heading)`
  letter-spacing: 0.75px;
  line-height: 1.05em;
  text-shadow: 0px 0px 2px #101010;
  margin-bottom: 10px;
  `;

const Paragraph = styled(Text)`
  font-weight: 500;
  font-family: 'Sunflower';
  letter-spacing: 0.5px;
  line-height: 1.1em;
  color: #40D082;
  text-shadow: 0px 0px 1px #101010;
`;

const CustomListItem = styled(ListItem)`
  font-size: 1.25em;
  font-family: 'Sunflower';
  text-shadow: 0px 0px 2px #101010;
`;


export default class Presentation extends React.Component {
  render() {
    return (
      <Deck theme={theme} progress={'none'} transition={["fade"]} controls={false}>
        <Slide bgImage={'assets/bg-slide-1.jpg'} bgColor={'#080810'}>
          <Notes>
            <ul>
              <li>Introduction to Basics of React 360 and VR</li>
              <li>Context = WebVR, Three.js, WebGL</li>
              <li>45min Presentation by Samuli Hakoniemi (samuli@hakoniemi.net)</li>
              <li>Presented in React Helsinki, 13th of June 2018</li>
            </ul>
          </Notes>
          <NiceHeading className={'odd'} size={1} fit caps textColor={'primary'}>
            {'React 360'}
          </NiceHeading>
          <Paragraph style={{fontSize: '2em'}}>The World Around Us</Paragraph>
        </Slide>

        <Slide bgImage={'assets/bg-slide-2.jpg'} bgColor={'#080810'}>
          <Notes>
            <ul>
              <li>VR was published in April 2017</li>
              <li>360 was published in May 2018</li>
              <li>The codebase has diverged a lot, major update was renamed to 360</li>
              <li>React VR never emerged, 360 aims to be more prominent option for VR devs</li>
              <li>360 has better support for different media types, like for videos</li>
              <li>360 has better performance – blazing fast :)</li>
            </ul>
          </Notes>
          <NiceHeading className={'even'} size={1} textColor={'primary'}>
            {'React 360'}<br/> {'is not'}<br/> {'React VR'}
          </NiceHeading>
        </Slide>

        <Slide bgImage={'assets/bg-slide-3.jpg'} bgColor={'#080810'}>
          <Notes>
            <ul>
              <li>Installing react-360-cli (npm or yarn)</li>
              <li>Initialising the project</li>
              <li>Starting the Server</li>
            </ul>
          </Notes>
          <NiceHeading className={'odd'} size={1} textColor={'primary'}>
            {"Let's Get Started"}
          </NiceHeading>
          <Image src='assets/installing.png'/>
        </Slide>

        <Slide bgImage={'assets/bg-slide-4.jpg'} bgColor={'#080810'}>
          <Notes>
            <ul>
              <li>index.js - contains the main code of your application.</li>
              <li>index.html - contains the HTML placeholder / view which inits your application.</li>
              <li>client.js - creates a new instance of React 360 application, then it renders your code into scene and finally applies the background image into the scene.</li>
            </ul>
          </Notes>
          <NiceHeading className={'even'} size={1} textColor={'primary'}>
            {'Project Structure'}
          </NiceHeading>
          <SubHeading size={3} textColor={'secondary'}>{'index.js'}</SubHeading>
          <SubHeading size={3} textColor={'secondary'}>{'index.html'}</SubHeading>
          <SubHeading size={3} textColor={'secondary'}>{'client.js'}</SubHeading>
        </Slide>

        <Slide bgImage={'assets/bg-slide-5.jpg'} bgColor={'#080810'}>
          <Notes>
            <ul>
              <li>Similar with React Native</li>
              <li>View - Base Wrapper (like div)</li>
              <li>Text - only one font family, custom must be explicitly exported</li>
              <li>Image - simple API</li>
              <li>Entity - for rendering 3D Objects</li>
              <li>VrButton - an abstract wrapper for detecting “click-type” events</li>
              <li>Styling can be complex and unintuitive – see following slides</li>
            </ul>
          </Notes>
          <NiceHeading className={'odd'} size={1} textColor={'primary'}>
            {'Core Components'}
          </NiceHeading>
          <SubHeading size={3} textColor={'secondary'}>{'<View>, <Text>, <Image>, <Entity>, <VrButton>'}</SubHeading>
        </Slide>

        <Slide bgImage={'assets/bg-slide-6.jpg'} bgColor={'#080810'}>
          <Notes>
            <ul>
              <li>1000 x 600 is full surface</li>
              <li>Cylinder (3D) vs Flat (2D)</li>
            </ul>
          </Notes>
          <NiceHeading className={'even'} size={1} textColor={'primary'}>
            {'Layout is Wicked'}
          </NiceHeading>
          <SubHeading size={3} textColor={'secondary'}>{'1000 x 600'}</SubHeading>
          <SubHeading size={3} textColor={'secondary'}>{'3D vs 2D'}</SubHeading>
        </Slide>

        <Slide bgImage={'assets/bg-slide-7.jpg'} bgColor={'#080810'}>
          <Notes>
            <ul>
              <li>Surfaces are imported through AppRegistry</li>
              <li>Position (angle) of surfaces are defined in Client.js (not with Styling)</li>
            </ul>
          </Notes>
          <Image src={'assets/surfaces.jpg'} style={{border: '2px outset #202020', boxShadow: '0px 0px 5px #333333'}} />
        </Slide>

        <Slide bgImage={'assets/bg-slide-8.jpg'} bgColor={'#080810'}>
          <NiceHeading className={'even'} size={1} textColor={'primary'}>
            {'Live Coding: Project Bottlist'}
          </NiceHeading>
          <Paragraph className={'even'}>{'When browsing and comparing beverages happens in virtual reality.'}</Paragraph>
        </Slide>

        <Slide bgImage={'assets/bg-slide-9.jpg'} bgColor={'#080810'}>
          <Notes>
            <ul>
              <li>Not mature yet</li>
              <li>“Perfect” for React / RN Developers</li>
              <li>Good introduction to VR</li>
            </ul>
          </Notes>
          <NiceHeading className={'odd'} size={1} textColor={'primary'}>
            {'Recap and Conclusions'}
          </NiceHeading>
          <Paragraph className={'odd'}>{"React 360 is not mature, but it's very prominent framework especially for React / RN devs. It provides a basic toolset to get started with VR."}</Paragraph>
        </Slide>

        <Slide bgImage={'assets/bg-slide-10.jpg'} bgColor={'#080810'}>
          <NiceHeading className={'even'} size={1} textColor={'primary'}>
            {'Resources'}
          </NiceHeading>
          <List>
            <CustomListItem><Link textColor={'tertiary'} href={'https://facebook.github.io/react-360/'}>{'React 360 Docs | FB'}</Link></CustomListItem>
            <CustomListItem><Link textColor={'tertiary'} href={'hhttps://developer.oculus.com/documentation/'}>{'VR Docs | Oculus'}</Link></CustomListItem>
            <CustomListItem><Link textColor={'tertiary'} href={'https://facebook.github.io/react-360/docs/from-react-vr.html'}>{'Migrating from React VR'}</Link></CustomListItem>
            <CustomListItem><Link textColor={'tertiary'} href={'https://viromedia.com/viroreact/'}>{'Viro React'}</Link></CustomListItem>
          </List>
          <List>
            <CustomListItem><Link textColor={'tertiary'} href={'https://medium.com/@zvona'}>{'My Blog on Medium'}</Link></CustomListItem>
            <CustomListItem><Link textColor={'tertiary'} href={'https://twitter.com/zvona'}>{"I'm @zvona on Twitter"}</Link></CustomListItem>
            <CustomListItem><Link style={{fontSize: '0.6em'}} textColor={'tertiary'} href={'http://presentations.hakoniemi.net/react-360/#/0?presenter'}>{'presentations.hakoniemi.net/react-360'}</Link></CustomListItem>
          </List>
        </Slide>
        <Slide bgImage={'assets/bg-slide-11.jpg'} bgColor={'#080810'}>
          <NiceHeading className={'odd'} size={1} textColor={'primary'}>
            {'Thank you,'}<br />{'React Helsinki!'}
          </NiceHeading>
          <SubHeading size={3} textColor={'secondary'}>{'Questions? Feedback?'}</SubHeading>
        </Slide>
      </Deck>
    );
  }
}



// WEBPACK FOOTER //
// ./src/presentation.js